<a (click)='onClickDocumentRepository({item: item, fieldDefinition: fieldDefinition})'
   class="flex flex-row justify-start items-center"
   particleAnalytics
   [ngClass]="disabled ? 'link-color' : 'disabled'"
   analyticsCategory="document-repository-cell-viewer"
   [analyticsAction]="item.cells[fieldDefinition.key]?.displayText"
>
  <div class="flex flex-row justify-between items-center full-grow-no-shrink-no-basis">
    <div class="container flex flex-row justify-start items-center full-grow-no-shrink-no-basis ">
      <div class="m-r-10">
        <div class="{{item.cells['Icon']?.value}}"></div>
      </div>
      <div>
        {{item.cells[fieldDefinition.key]?.displayText}}
      </div>
    </div>
    <button mat-button *ngIf="item?.cells?.IsCheckedOut?.value" class="checkout-button"
            particleAnalytics
            analyticsCategory="checked-out"
            analyticsAction="checked-out">
      CHECKED OUT
    </button>
  </div>

</a>
